import React from 'react';
import { BaseBlockModel, BlockType, TcsmActionBlock, TcsmResourceBlock, TcsmNewsUpdateBlock, TcsmLinkBlock, TcsmVideoBlock, TcsmDatesBlock, TcsmParagraphBlock, TcsmInformationBlock, TcsmButtonBlock, TcsmAnnualEnrollmentMessageBlock, RedesignCalendarWidgetBlockModel, RedesignCalloutBlock, RedesignRelatedLinksBlock, ContentRecommendationsBlockModel } from '../models/tcsm-block-models';
import { TcsmActionBlockView } from './block-type/tcsm-action-block';
import { TcsmNewsUpdateBlockView } from './block-type/tcsm-news-update-block';
import { TcsmResourceBlockView } from './block-type/tcsm-resource-block';
import { TcsmContentLinkView } from './tcsm-content-link';

const TcsmVideoBlockView = React.lazy(() => import('./block-type/tcsm-video-block'));
const TcsmDatesBlockView = React.lazy(() => import('./block-type/tcsm-dates-block'));
const TcsmParagraphBlockView = React.lazy(() => import('./block-type/tcsm-paragraph-block'));
const TcsmInformationBlockView = React.lazy(() => import('./block-type/tcsm-information-block'));
const TcsmButtonBlockView = React.lazy(() => import('./block-type/tcsm-button-block'));
const TcsmAnnualEnrollmentMessageBlockView = React.lazy(() => import('./block-type/tcsm-annual-enrollment-message-block'));
const CalendarWidgetView = React.lazy(() => import('../../standalone-app/event-calendar/calendar-widget'));
const RedesignCalloutBlockView = React.lazy(() => import('./block-type/redesign-callout-block'));
const RedesignRelatedLinksBlockView = React.lazy(() => import('./block-type/redesign-related-links-block'));
const ContentRecommendationsBlockView = React.lazy(() => import('./block-type/content-recommendations-block'));


interface Props {

	blockData: BaseBlockModel,
}

export const BlockFactory = (props: Props) => {

	switch (props.blockData?.blockType) {
		case BlockType.TcsmResourceBlock: {
			return <TcsmResourceBlockView blockData={props.blockData as TcsmResourceBlock} />;
		}

		case BlockType.TcsmActionBlock: {
			return <TcsmActionBlockView blockData={props.blockData as TcsmActionBlock} />;
		}

		case BlockType.TcsmNewsUpdateBlock: {
			return <TcsmNewsUpdateBlockView blockData={props.blockData as TcsmNewsUpdateBlock} />;
		}

		case BlockType.TcsmLinkBlock: {
			return <TcsmContentLinkView link={props.blockData as TcsmLinkBlock} />;
		}

		case BlockType.TcsmVideoBlock: {
			return <TcsmVideoBlockView blockData={props.blockData as TcsmVideoBlock} />;
		}

		case BlockType.TcsmDatesBlock: {
			return <TcsmDatesBlockView blockData={props.blockData as TcsmDatesBlock} />;
		}

		case BlockType.TcsmParagraphBlock: {
			return <TcsmParagraphBlockView blockData={props.blockData as TcsmParagraphBlock} />;
		}

		case BlockType.TcsmInformationBlock: {
			return <TcsmInformationBlockView blockData={props.blockData as TcsmInformationBlock} />;
		}

		case BlockType.TcsmButtonBlock: {
			return <TcsmButtonBlockView blockData={props.blockData as TcsmButtonBlock} />;
		}

		case BlockType.TcsmAnnualEnrollmentMessageBlock: {
			return <TcsmAnnualEnrollmentMessageBlockView blockData={props.blockData as TcsmAnnualEnrollmentMessageBlock} />;
		}

		case BlockType.RedesignCalendarWidgetBlock: {
			const settings = (props.blockData as RedesignCalendarWidgetBlockModel).widgetSettings;
			return settings ? <CalendarWidgetView {...settings} /> : null;
		}

		case BlockType.RedesignCalloutBlock: {
			return <RedesignCalloutBlockView blockData={props.blockData as RedesignCalloutBlock} />;
		}

		case BlockType.RedesignRelatedLinksBlock: {
			return <RedesignRelatedLinksBlockView blockData={props.blockData as RedesignRelatedLinksBlock} />;
		}

		case BlockType.ContentRecommendationsBlock: {
			return <ContentRecommendationsBlockView blockData={props.blockData as ContentRecommendationsBlockModel} />;
		}

		default: {
			return <>Unknown block type &apos;{props.blockData?.blockType}&apos;</>;
		}
	}

};


